export default __webpack_public_path__ + "static/media/page6.1ef73ffd.png";